import { UserRoleEnum } from '../tools/constants';

export const getUserRole = (role?: string) => {
  if (role == UserRoleEnum?.ROLE_ADMIN) return 'Admin';
  else if (role == UserRoleEnum?.ROLE_AGENT) return 'Agent';
  else if (role == UserRoleEnum?.ROLE_CLINICIAN) return 'Clinician';
};
